/**
 * Scrolls to an element by id, accounting for the fixed navbar height and
 * re-correcting the position after lazy-loaded images shift the layout.
 *
 * Native anchor scrolling (#contact) can land short when images above the
 * target finish loading after the browser has already calculated the scroll
 * position. This handler re-measures and re-scrolls to eliminate that drift.
 */
export function scrollToId(id: string, offset = 90) {
  const raw = id.startsWith("#") ? id.slice(1) : id;
  const el = document.getElementById(raw);
  if (!el) return;

  const jump = () => {
    const top = el.getBoundingClientRect().top + window.scrollY - offset;
    window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
  };

  // Initial smooth scroll.
  jump();

  // Re-correct after images above have likely loaded / layout settled.
  // A few staggered passes catch most lazy-load shifts without being jarring.
  window.setTimeout(jump, 250);
  window.setTimeout(jump, 600);
  window.setTimeout(jump, 1000);
}
